import {ComponentMappingConfig} from '../../shared/services/components-factory.service';
import {NotificationComponentKey, SectionComponentKey} from '../enums/components-keys';
import {
    PositiveNotificationWebComponent
} from '../../shared/sections/notifications/positive-notification/positive-notification-web.component';
import {
    ErrorNotifySectionWebComponent
} from '../../shared/sections/web/error-notify-section/error-notify-section-web.component';
import {
    PaymentAcceptNotificationComponent
} from '../../shared/sections/notifications/payment-accept-notification/payment-accept-notification.component';
import {
    InsurerDataAuthorizationComponent
} from '../../shared/sections/notifications/insurer-data-authorization-notification/insurer-data-authorization.component';
import {
    InsurerFailedDataAuthorizationComponent
} from '../../shared/sections/notifications/insurer-failed-data-authorization-notification/insurer-failed-data-authorization.component';
import {
    NextSuccessNotificationComponent
} from '../../shared/sections/notifications/next-success-notification/next-success-notification.component';
import {
    ConnectionErrorNotificationWebComponent
} from '../../shared/sections/notifications/connection-error-notification/connection-error-notification-web.component';
import {
    ErrorNotificationWebComponent
} from '../../shared/sections/notifications/error-notification/error-notification-web.component';
import {
    SessionErrorNotificationWebComponent
} from '../../shared/sections/notifications/session-error-notification/session-error-notification-web.component';
import {
    InsurerDataSectionComponent
} from '../../shared/sections/web/insurer-data-section/insurer-data-section.component';
import {AgreementsSectionComponent} from '../../shared/sections/web/agreements-section/agreements-section.component';
import {
    SelectedOfferSectionComponent
} from '../../shared/sections/web/selected-offer-section/selected-offer-section.component';
import {OfferSectionComponent} from '../../shared/sections/web/offer-section/offer-section.component';
import {NextOffersSectionComponent} from '../../shared/sections/web/next-offers-section/next-offers-section.component';
import {
    OfferRecommendationsSectionComponent
} from '../../shared/sections/web/offer-recommendations-section/offer-recommendations-section.component';
import {
    MethodPaymentsSectionComponent
} from '../../shared/sections/web/method-payments-section/method-payments-section.component';
import {
    NextPaymentMethodSectionComponent
} from '../../shared/sections/web/next-payment-method-section/next-payment-method-section.component';
import {VehicleUseSectionComponent} from '../../shared/sections/web/vehicle-use-section/vehicle-use-section.component';
import {
    VehicleDataSectionComponent
} from '../../shared/sections/web/vehicle-data-section/vehicle-data-section.component';
import {
    SalesMessagesSectionComponent
} from '../../shared/sections/web/sales-messages-section/sales-messages-section.component';
import {
    AdditionalContentSectionComponent
} from '../../shared/sections/web/additional-content-section/additional-content-section.component';
import {OwnerDataSectionComponent} from '../../shared/sections/web/owner-data-section/owner-data-section.component';
import {InformationSectionComponent} from '../../shared/sections/web/information-section/information-section.component';
import {
    VehicleModelSectionComponent
} from '../../shared/sections/web/vehicle-model-section/vehicle-model-section.component';
import {
    AdditionalInformationSectionComponent
} from '../../shared/sections/web/additional-information-section/additional-information-section.component';
import {InstallmentSectionComponent} from '../../shared/sections/web/installment-section/installment-section.component';
import {CessionSectionComponent} from '../../shared/sections/web/cession-section/cession-section.component';
import {AztecSectionComponent} from '../../shared/sections/mobile/aztec-section/aztec-section.component';
import {
    ContactDataSectionComponent
} from '../../shared/sections/web/contact-data-section/contact-data-section.component';
import {
    ContactInsurerDataSectionComponent
} from '../../shared/sections/web/contact-insurer-data-section/contact-insurer-data-section.component';
import {
    InsuranceCoveragesSectionComponent
} from '../../shared/sections/web/insurance-coverages-section/insurance-coverages-section.component';
import {
    InformationClauseSectionComponent
} from '../../shared/sections/web/information-clause-section/information-clause-section.component';
import {
    DiscountCodesSectionComponent
} from '../../shared/sections/web/discount-codes-section/discount-codes-section.component';
import {AcVariantsSectionComponent} from '../../shared/sections/web/ac-variants-section/ac-variants-section.component';
import {
    AcVariantsBeesafeSectionComponent
} from '../../shared/sections/web/ac-variants-beesafe-section/ac-variants-beesafe-section.component';
import {
    AdditionalOptionsSectionComponent
} from '../../shared/sections/web/additional-options-section/additional-options-section.component';
import {
    AdditionalOptionsBeesafeSectionComponent
} from '../../shared/sections/web/additional-options-beesafe-section/additional-options-beesafe-section.component';
import {
    UniqaDiscountCodeSectionComponent
} from '../../shared/sections/web/uniqa-discount-code-section/uniqa-discount-code-section.component';
import {
    PersonalDataAdministratorSectionComponent
} from '../../shared/sections/web/personal-data-administrator-section/personal-data-administrator-section.component';
import {
    PowerOfAttorneySectionComponent
} from '../../shared/sections/web/power-of-attorney-section/power-of-attorney-section.component';
import {
    AdditionalDataSectionComponent
} from '../../shared/sections/web/additional-data-section/additional-data-section.component';
import {
    CalculationsCacheSectionComponent
} from '../../shared/sections/web/calculations-cache-section/calculations-cache-section.component';
import {
    InitialDataSectionComponent
} from '../../shared/sections/web/initial-data-section/initial-data-section.component';
import {
    CalculationAgreementsSectionComponent
} from '../../shared/sections/web/calculation-agreements-section/calculation-agreements-section.component';

export const COMPONENTS_FACTORY_MAPPING: ComponentMappingConfig[] = [
    // section components
    {
        key: SectionComponentKey.INSURER_DATA,
        component: InsurerDataSectionComponent
    },
    {
        key: SectionComponentKey.AGREEMENTS,
        component: AgreementsSectionComponent
    },
    {
        key: SectionComponentKey.MOBILE_SELECTED_OFFER,
        component: SelectedOfferSectionComponent
    },
    {
        key: SectionComponentKey.SELECTED_OFFER,
        component: SelectedOfferSectionComponent
    },
    {
        key: SectionComponentKey.OFFER,
        component: OfferSectionComponent
    },
    {
        key: SectionComponentKey.NEXT_OFFERS,
        component: NextOffersSectionComponent
    },
    {
        key: SectionComponentKey.OFFER_RECOMMENDATIONS,
        component: OfferRecommendationsSectionComponent
    },
    {
        key: SectionComponentKey.METHOD_PAYMENTS,
        component: MethodPaymentsSectionComponent
    },
    {
        key: SectionComponentKey.NEXT_PAYMENT_METHOD,
        component: NextPaymentMethodSectionComponent
    },
    {
        key: SectionComponentKey.VEHICLE_USE,
        component: VehicleUseSectionComponent
    },
    {
        key: SectionComponentKey.VEHICLE_DATA,
        component: VehicleDataSectionComponent
    },
    {
        key: SectionComponentKey.SALES_MESSAGES,
        component: SalesMessagesSectionComponent
    },
    {
        key: SectionComponentKey.ADDITIONAL_CONTENT,
        component: AdditionalContentSectionComponent
    },
    {
        key: SectionComponentKey.OWNER_DATA,
        component: OwnerDataSectionComponent
    },
    {
        key: SectionComponentKey.INFORMATION,
        component: InformationSectionComponent
    },
    {
        key: SectionComponentKey.INITIAL_DATA,
        component: InitialDataSectionComponent
    },
    {
        key: SectionComponentKey.CALCULATION_AGREEMENTS,
        component: CalculationAgreementsSectionComponent
    },
    {
        key: SectionComponentKey.VEHICLE_MODEL,
        component: VehicleModelSectionComponent
    },
    {
        key: SectionComponentKey.ADDITIONAL_INFORMATION,
        component: AdditionalInformationSectionComponent
    },
    {
        key: SectionComponentKey.INSTALLMENT,
        component: InstallmentSectionComponent
    },
    {
        key: SectionComponentKey.CESSION,
        component: CessionSectionComponent
    },
    {
        key: SectionComponentKey.AZTEC,
        component: AztecSectionComponent
    },
    {
        key: SectionComponentKey.CONTACT_DATA,
        component: ContactDataSectionComponent
    },
    {
        key: SectionComponentKey.CONTACT_INSURER_DATA,
        component: ContactInsurerDataSectionComponent
    },
    {
        key: SectionComponentKey.INSURANCE_COVERAGES,
        component: InsuranceCoveragesSectionComponent
    },
    {
        key: SectionComponentKey.INFORMATION_CLAUSE,
        component: InformationClauseSectionComponent
    },
    {
        key: SectionComponentKey.DISCOUNT_CODES,
        component: DiscountCodesSectionComponent
    },
    {
        key: SectionComponentKey.AC_VARIANTS,
        component: AcVariantsSectionComponent
    },
    {
        key: SectionComponentKey.AC_VARIANTS_BEESAFE,
        component: AcVariantsBeesafeSectionComponent
    },
    {
        key: SectionComponentKey.ADDITIONAL_OPTIONS,
        component: AdditionalOptionsSectionComponent
    },
    {
        key: SectionComponentKey.ADDITIONAL_OPTIONS_BEESAFE,
        component: AdditionalOptionsBeesafeSectionComponent
    },
    {
        key: SectionComponentKey.AXA_DISCOUNT_CODE,
        component: UniqaDiscountCodeSectionComponent
    },
    {
        key: SectionComponentKey.PERSONAL_DATA_ADMINISTRATOR,
        component: PersonalDataAdministratorSectionComponent
    },
    {
        key: SectionComponentKey.POWER_OF_ATTORNEY,
        component: PowerOfAttorneySectionComponent
    },
    {
        key: SectionComponentKey.ADDITIONAL_DATA,
        component: AdditionalDataSectionComponent
    },
    {
        key: SectionComponentKey.CALCULATIONS_CACHE,
        component: CalculationsCacheSectionComponent
    },

    // notification components
    {
        key: NotificationComponentKey.PAYMENT_SUCCESS,
        component: PositiveNotificationWebComponent
    },
    {
        key: NotificationComponentKey.PAYMENT_ERROR,
        component: ErrorNotifySectionWebComponent
    },
    {
        key: NotificationComponentKey.PAYMENT_ACCEPT,
        component: PaymentAcceptNotificationComponent
    },
    {
        key: NotificationComponentKey.AUTHORIZATION_INSURER_DATA,
        component: InsurerDataAuthorizationComponent
    },
    {
        key: NotificationComponentKey.REGISTRATION_FAILED,
        component: InsurerFailedDataAuthorizationComponent
    },
    {
        key: NotificationComponentKey.NEXT_SUCCESS,
        component: NextSuccessNotificationComponent
    },
    {
        key: NotificationComponentKey.CONNECTION_ERROR,
        component: ConnectionErrorNotificationWebComponent
    },
    {
        key: NotificationComponentKey.ERROR,
        component: ErrorNotificationWebComponent
    },
    {
        key: NotificationComponentKey.SESSION_ERROR,
        component: SessionErrorNotificationWebComponent
    }
];
